<template>
  <span>{{timeText}}</span>
</template>

<script>
  import DateTime from "@/mixins/dateTime";

  export default {
    name: 'human-duration',
    props: {
      seconds: {
        type: [Number, String],
        required: true
      },
      defaultValue: {
        type: String,
        default: ""
      }
    },
    mixins: [DateTime],
    computed: {
      timeText() {
        let timeStr = this.toHHMM(this.seconds, this.defaultValue);
        if (timeStr !== this.defaultValue) {
          timeStr += this.$t('measure.shortcut.hours');
        }
        return timeStr;
      }
    }
  }
</script>
